import mobileAdjustment from "../GeneralMobileAdjustments";

class MobileHorizontalSliderControlView {

    constructor() { }

    afterRender(control) {
        let element = mobileAdjustment.adjustMobileControl(control);
        let slider = element.find("div:first");
        slider.css("width","100%");

        let min = slider.find("span.h-slider-label.min");
        min.css('bottom', '10px');
        let max = slider.find("span.h-slider-label.max");
        max.css('bottom', '10px');
    }
}

const mobileHorizontalSliderControlView = new MobileHorizontalSliderControlView();
export default mobileHorizontalSliderControlView;